import React from 'react';
import { QuickFilter } from '../../../redux/slices/marketplaceSlice';
import './FilterBar.scss';

interface FilterBarProps {
  activeFilter: QuickFilter;
  onFilterChange: (filter: QuickFilter) => void;
}

const FilterBar: React.FC<FilterBarProps> = ({ activeFilter, onFilterChange }) => {
  const filters: { value: QuickFilter; label: string; icon: string }[] = [
    { value: 'spotlight', label: 'Spotlighted', icon: '✨' },
    { value: 'all', label: 'All Profiles', icon: '🌐' },
    { value: 'top', label: 'Top Profiles', icon: '⭐' },
    { value: 'cheapest', label: 'Cheapest', icon: '💰' },
    { value: 'most-bought', label: 'Most Popular', icon: '🔥' },
    { value: 'least-bought', label: 'Hidden Gems', icon: '💎' },
    // Opt-in agents tab. Every other tab excludes agents by default
    // (see MarketplaceController is_agent gate); this one flips it
    // to show agents-only. Discover Agents (/agents/discover) is
    // still the primary agent-browsing surface — this is an
    // owner-side escape hatch for people who want to filter the
    // marketplace UI to agents.
    { value: 'agents', label: 'Agents', icon: '🤖' },
  ];

  return (
    <div className="filter-bar">
      <div className="filter-bar-scroll">
        {filters.map((filter) => (
          <button
            key={filter.value}
            className={`filter-btn ${activeFilter === filter.value ? 'active' : ''}`}
            onClick={() => onFilterChange(filter.value)}
            type="button"
          >
            <span className="filter-icon">{filter.icon}</span>
            <span className="filter-label">{filter.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default FilterBar;
